/* oxlint-disable */
import { FilterState, PaginationState, SearchState } from '../interfaces/filter.interface';
import { Game } from '../interfaces/game.interface';

export interface CasinoState {
  games: Game[];
  loading: boolean;
  error: string | null;
  filters: FilterState;
  search: SearchState;
  selectedView: 'lobby' | 'games';
  sortBy: 'newest' | 'popular' | 'alphabetical';
  pagination: PaginationState;
}

export const initialState: CasinoState = {
  games: [],
  loading: false,
  error: null,
  filters: {
    categories: [],
    providers: [],
    collections: [],
  },
  search: {
    query: '',
    suggestions: [],
    isSearching: false,
  },
  selectedView: 'lobby',
  sortBy: 'newest',
  pagination: {
    currentPage: 0,
    hasMore: true,
    totalCount: 0,
  },
};

export type CasinoAction =
  | { type: 'SET_GAMES'; payload: { games: Game[]; reset?: boolean } }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_FILTERS'; payload: Partial<FilterState> }
  | { type: 'CLEAR_FILTERS' }
  | { type: 'TOGGLE_FILTER'; payload: { type: keyof FilterState; value: string } }
  | { type: 'SET_SEARCH_QUERY'; payload: string }
  | { type: 'SET_SUGGESTIONS'; payload: any[] }
  | { type: 'SET_SEARCHING'; payload: boolean }
  | { type: 'CLEAR_SEARCH' }
  | { type: 'SET_SELECTED_VIEW'; payload: 'lobby' | 'games' }
  | { type: 'SET_SORT_BY'; payload: 'newest' | 'popular' | 'alphabetical' }
  | { type: 'SET_PAGINATION'; payload: Partial<PaginationState> }
  | { type: 'CLEAR_GAMES' }
  | { type: 'RESET_ALL' };

export function casinoReducer(state: CasinoState, action: CasinoAction): CasinoState {
  switch (action.type) {
    case 'SET_GAMES':
      return {
        ...state,
        games: action.payload.reset ? action.payload.games : [...state.games, ...action.payload.games],
        loading: false,
        error: null,
      };

    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case 'SET_FILTERS':
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
      };

    case 'CLEAR_FILTERS':
      return {
        ...state,
        filters: {
          categories: [],
          providers: [],
          collections: [],
        },
      };

    case 'TOGGLE_FILTER': {
      const currentValues = state.filters[action.payload.type];
      const newValues = currentValues.includes(action.payload.value) ? currentValues.filter((v) => { return v !== action.payload.value; }) : [...currentValues, action.payload.value];

      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.type]: newValues,
        },
      };
    }

    case 'SET_SEARCH_QUERY':
      return {
        ...state,
        search: { ...state.search, query: action.payload },
      };

    case 'SET_SUGGESTIONS':
      return {
        ...state,
        search: { ...state.search, suggestions: action.payload },
      };

    case 'SET_SEARCHING':
      return {
        ...state,
        search: { ...state.search, isSearching: action.payload },
      };

    case 'CLEAR_SEARCH':
      return {
        ...state,
        search: {
          query: '',
          suggestions: [],
          isSearching: false,
        },
      };

    case 'SET_SELECTED_VIEW':
      return {
        ...state,
        selectedView: action.payload,
      };

    case 'SET_SORT_BY':
      return {
        ...state,
        sortBy: action.payload,
      };

    case 'SET_PAGINATION':
      return {
        ...state,
        pagination: { ...state.pagination, ...action.payload },
      };

    case 'CLEAR_GAMES':
      return {
        ...state,
        games: [],
        pagination: {
          currentPage: 0,
          hasMore: true,
          totalCount: 0,
        },
      };

    case 'RESET_ALL':
      return {
        ...initialState,
        selectedView: state.selectedView,
      };

    default:
      return state;
  }
}
